// @ts-strict-ignore
import { ProjectVO } from './project.vo';
import { OBJRepresentationDataVO } from '@shared/vo/representation.vo';

export class ImportedCaeProjectDTO {
  public project: ProjectVO;
  public data: OBJRepresentationDataVO;
}
